import { useI18n } from '../i18n/useI18n'
import { userMessageForCode } from '../lib/userError'

interface Props {
  code: string
  onHome: () => void
}

/**
 * Human-facing share availability page.
 *
 * The backend only redirects here with a normalized status code. All visible
 * copy belongs to the frontend so it can later be selected from locale files.
 */
export function ShareUnavailableNotice({ code, onHome }: Props) {
  const { t } = useI18n()
  const message = userMessageForCode(code, t('share.unavailable.fallback'))

  return (
    <main className="page">
      <section className="card" role="status" aria-live="polite">
        <span className="badge">mioSegno</span>
        <h1>{t('share.unavailable.title')}</h1>
        <p className="muted">{message}</p>
        <div className="control-row">
          <button className="button primary" type="button" onClick={onHome}>
            {t('share.unavailable.home')}
          </button>
        </div>
      </section>
    </main>
  )
}
